module.exports = "/assets/data/7c5747745ee4c29e76a53f99af5f942d-BL0.data.json";